(function () {
  // Passe die Selector-Liste an, falls dein Badge anders heißt
  const COUNT_SELECTORS = [
    ".cart-count",                 // wird bei dir im cart.liquid benutzt
    "[data-cart-count]",           // falls vorhanden
    ".header__cart-count",         // häufig in Themes
    ".cart-bubble__text",          // häufig in Themes
    ".cart-bubble",                // fallback
    ".section-header-cart-count"   // fallback
  ];

  async function fetchCartCount() {
    try {
      const r = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await r.json();
      return Number(cart.item_count || 0);
    } catch (e) {
      return null;
    }
  }

  function applyCount(count) {
    if (count == null) return;

    COUNT_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        // Wenn es ein Input ist:
        if (el.tagName === "INPUT") el.value = count;
        else el.textContent = count;

        // Optional: verstecken wenn 0
        el.style.display = (count > 0) ? "" : "none";
      });
    });
  }

  async function refreshCount() {
    const count = await fetchCartCount();
    applyCount(count);
  }

  // 1) Beim Laden einmal setzen
  document.addEventListener("DOMContentLoaded", refreshCount);

  // 2) Wenn Drawer aufgeht (dein Code nutzt .active)
  document.addEventListener("click", (e) => {
    const t = e.target.closest(".section-header-cart-drawer-toggle");
    if (t) setTimeout(refreshCount, 250);
  });

  // 3) WICHTIG: Nach JEDEM Cart-Fetch automatisch aktualisieren
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = (typeof args[0] === "string") ? args[0] : (args[0]?.url || "");
      const isCartCall =
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear");

      if (isCartCall) setTimeout(refreshCount, 150);
    } catch (e) {}

    return res;
  };

  // 4) Wenn du + / - klickst (falls dein Theme NICHT über fetch läuft)
  document.addEventListener("click", (e) => {
    if (e.target.closest(".qty-plus, .qty-minus")) {
      setTimeout(refreshCount, 300);
    }
  });

})();

